import styled from 'styled-components';

export const LoadingContainer = styled.div`
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  z-index: 10;

  @media print {
    & {
      display: none;
    }
  }
`;
